import { BaseTextFieldProps, InputField } from './InputField';
import { JoditEditor } from '../../common/JoditEditor';

interface EditorFieldProps extends BaseTextFieldProps {
    limitHTML?: boolean;
    countHTMLChars?: boolean;
}

export const EditorField = ({ maxLength, limitHTML, countHTMLChars, ...props }: EditorFieldProps) => {
    return (
        <InputField {...props} renderElement={(formik, field, meta, helpers) => (
            <div className="data-item-col">
                <JoditEditor
                    maxLength={maxLength}
                    limitHTML={limitHTML}
                    countHTMLChars={countHTMLChars}
                    uploadBaseUrl={`${process.env.REACT_APP_AMR_ENDPOINT}`}
                    uploadPath={'/api/bwic/news/image'}
                    value={field.value || ''}
                    onChange={value => {
                        formik.setFieldValue(field.name, value);
                        helpers.setTouched(true);
                    }}
                    placeholder="Add Event Description"
                />
                {meta.touched && meta.error && <div className="form-error">{meta.error}</div>}
            </div>
        )} />
    );
}
